import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'underscore';
import { getValueFromObject } from '../util/util';

@Pipe({
  name: 'find',
})
export class FindPipe implements PipeTransform {
  transform(value: any[], searchFor: any | any[], field?: string, negate?: boolean): any {
    if (!value) {
      return undefined;
    }
    return value.find((item) => {
      const check = getValueFromObject(item, field);
      const result = Array.isArray(searchFor) ? searchFor.includes(check) : check === searchFor;
      return negate ? !result : result;
    });
  }
}
